import { Kbd, LoadingOverlay, Modal, TextInput, useMantineTheme } from "@mantine/core"
import { useDisclosure, useHotkeys } from "@mantine/hooks"
import { IconSearch } from "@tabler/icons-react"
import dayjs from "dayjs"
import { useEffect, useRef, useState } from "react"
import LocaleSwitcher from "../../shared/i18n/locale-switcher"
import { useLazySearchQuery } from "../store/layout.store"
import EmptyIcon from "../../shared/component/empty-icon/empty-icon"
import { useTranslation } from "react-i18next"
import { Link, useNavigate, useNavigation } from "react-router-dom"
import { debounce } from "lodash"
import { useCurrentUser } from "../../shared/hooks/current-user.hook"



// const tutorials: { for: string; component: ReactNode }[] = [
//   {
//     for: '/', component: <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
//     <iframe
//       src="https://www.loom.com/embed/b9be003a5e5a465aad56c4990719877d?sid=cec954ec-7ad4-4dcf-8cc9-0e150a1b111e"
//       frameBorder="0"
//       allow="fullscreen"
//       allowFullScreen
//       style={{
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//       }}
//     ></iframe>
//   </div>
//   },
//   {
//     for: '/owner',
//     component: <>Video is coming soon</>
//   }
// ]

const Header = ({ title }: { title: string }) => {
  // const [opened, { open, close }] = useDisclosure()
  // const { pathname } = useLocation()

  const [opened, { open, close }] = useDisclosure(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [search, searchResults] = useLazySearchQuery()
  const [ userInfo ] = useCurrentUser();
  const theme = useMantineTheme()
  const { t } = useTranslation()
  const navigate = useNavigate()


  // const debouncedSetSearchQuery = useRef(
  //   debounce((value: string) => {
  //     setSearchQuery(value);
  //   }, 1000)
  // ).current;

  const debouncedSearch = useRef(
    debounce((value: string) => {
      search(value)
      // Here you could call an API or filter results
    }, 1000)
  ).current;

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, []);

  // const handleChange = (event: any) => {
  //   debouncedSetSearchQuery(event.target.value);
  // };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchQuery(value); // for UI updates
    debouncedSearch(value); // debounced function
  };

  // const getTutorial = () => {
  // //   console.log("🚀 ~ Header ~ pathname:", pathname)
  //   return tutorials.find((tut) => tut.for === pathname)?.component
  // }

  useHotkeys([
    ['mod+K', () => open()],
  ]);

  // const handleSearch = () => {
  //   console.log("Searching for:", searchQuery)
  //   close()
  // }

  // useEffect(() => {

  //   // setTimeout(() => {
  //   search(searchQuery);
  //   // }, 1000);
  // }, [searchQuery])
  return (
    <header className=" w-full z-50 bg-gray-800 bg-opacity-50 backdrop-blur-md shadow-lg border-b border-gray-700 ">
      <div className="max-w-7xl mx-auto py-4 sm:px-6 lg:px-8 flex justify-between">
        <h1 className="text-2xl font-semibold text-gray-100 mx-2">{title}</h1>
        <div className="flex justify-center items-center gap-4 w-auto">
          {/* <Play className="cursor-pointer" onClick={() => open()} /> */}


          {userInfo?.role?.key === "owner" && (
            <>
              {/* Trigger button */}
              <div
                onClick={open}
                className="hidden md:flex items-center gap-2 px-4 py-0.5 rounded-md cursor-pointer bg-gray-700 dark:bg-dark-6 hover:bg-gray-600 dark:hover:bg-dark-600 transition-colors"
              >
                <span className="text-sm">Search here...</span>
                <div className="flex gap-1 ml-auto">
                  <Kbd>⌘</Kbd>
                  <Kbd>K</Kbd>
                </div>
              </div>
              <div
                onClick={open}
                className="flex md:hidden "
              >
                <IconSearch size={22} />
              </div>
              <Modal
                opened={opened}
                onClose={close}
                size="xl"
                radius="md"
                padding={0}
                classNames={{
                  content:
                    "bg-gray-800 dark:bg-dark-800 scrollbar-none  scrollbar-corner-background-accent scroll-smooth scrollbar-thumb-gray-700 scrollbar-track-gray-800 relative",
                  body: "p-0",
                  header: "py-1"
                }}
                closeOnClickOutside
                withCloseButton={false}
              >
                <LoadingOverlay
                  visible={searchResults.isLoading}
                  overlayBlur={2}
                // classNames={{
                //   overlay: "bg-gray-800 dark:bg-dark-800",
                //   loader: "dark:text-white",
                // }}
                />
                <div className="flex flex-col h-full">

                  <Modal.Header>
                    {/* Search header */}
                    <div className="p-6 pb-4 w-full">
                      <TextInput
                        placeholder="Search here..."
                        value={searchQuery}
                        // onChange={e => setSearchQuery(e.target.value)}
                        onChange={handleChange}
                        autoFocus
                        size="sm"
                        // variant="unstyled"
                        classNames={{
                          input:
                            "text-lg bg-grey-400 font-medium focus:outline-none w-full",
                        }}
                      />
                    </div>

                  </Modal.Header>


                  <Modal.Body>


                    <div className="border-t border-gray-200 dark:border-dark-5"></div>

                    {/* Results section */}



                    {/* {
                    searchResults && searchResults?.data?.units_index && searchResults?.data.units_index.length > 0 && (
                      <div className="flex flex-col gap-0">
                        <h2 className="px-10 pt-10">{t('unit', { count: 2 })}</h2>
                        <div className="flex-1 flex flex-col gap-4 overflow-auto max-h-[60vh] rounded-md mx-10 my-2 bg-gray-800 border-gray-400   scrollbar-corner-background-accent scroll-smooth scrollbar-thumb-gray-700 scrollbar-track-gray-800">
                          {searchResults?.data?.units_index?.map((result, index) => (
                            <div
                              key={index}
                              // to={`/uint/detail/active/${result?.id}`}
                              className="p-3 bg-gray-500 rounded-md hover:bg-gray-600 dark:hover:bg-dark-600 transition-colors"
                            >
                              <div className="flex flex-col gap-1">
                                <h4 className="text-lg font-semibold">
                                  {result?.name}
                                </h4>

                                <div className="flex items-center gap-2 mt-2">
                                  <span className="text-xs text-gray-200 dark:text-dark-3">
                                    {result?.unitArea ?? 0} KM<sup>2</sup>
                                  </span>
                                  {result?.occupied ? (
                                    <span className="bg-red-900 text-red-300 text-xs font-medium me-2 px-2.5 py-0.5 rounded-full dark:bg-red-900 dark:text-red-300">
                                      {t("occupied")}
                                    </span>
                                  ) : (
                                    <span className="bg-green-900 text-green-300 text-xs font-medium me-2 px-2.5 py-0.5 rounded-full dark:bg-green-900 dark:text-green-300">
                                      {t("available")}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                    )
                  } */}
                    {
                      searchResults && searchResults?.data?.properties_index && searchResults?.data.properties_index.length > 0 && (
                        <div className="flex flex-col gap-0">
                          <h2 className="px-10 pt-10">{t('property', { count: 2 })}</h2>
                          <div className="flex-1 flex flex-col gap-4 overflow-auto max-h-[60vh] rounded-md mx-10 my-2 bg-gray-800   scrollbar-corner-background-accent scroll-smooth scrollbar-thumb-gray-700 scrollbar-track-gray-800">
                            {searchResults?.data?.properties_index?.map((result, index) => (
                              <div

                                onClick={() => {
                                  close()
                                  navigate(`/property/detail/active/${result?.id}`);
                                }}
                                // to={}
                                key={index}
                                className="p-3 bg-gray-500 rounded-md dark:border-dark-5 hover:bg-gray-600 dark:hover:bg-dark-600 transition-colors cursor-pointer"
                              >
                                <div className="flex flex-col gap-1">
                                  <h4 className="text-lg font-semibold">
                                    {result?.name}
                                  </h4>
                                  {/* <p className="text-sm text-gray-500 dark:text-dark-2">
                                {result?.description}
                              </p> */}
                                  <div className="flex items-center gap-2 mt-2">
                                    <span className="px-2 py-1 text-xs rounded-full bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200">
                                      {result?.numberOfUnits} {t('unit', { count: result?.numberOfUnits })}
                                    </span>
                                    {/* <span className="text-xs text-gray-400 dark:text-dark-3">
                                  Updated {dayjs(result?.createdAt).format('MMM D, YYYY')}
                                </span> */}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>

                      )
                    }

                    {
                      searchResults && searchResults?.data?.tenants_index && searchResults?.data.tenants_index.length > 0 && (
                        <div className="flex flex-col gap-0">
                          <h2 className="px-10 pt-10">{t('tenant', { count: 2 })}</h2>
                          <div className="flex-1 flex flex-col gap-4 overflow-auto max-h-[60vh] rounded-md mx-10 my-2 bg-gray-800   scrollbar-corner-background-accent scroll-smooth scrollbar-thumb-gray-700 scrollbar-track-gray-800">
                            {searchResults?.data.tenants_index?.map((result, index) => (
                              <div
                                key={index}
                                onClick={() => {
                                  close()
                                  navigate(`/tenant/detail/active/${result?.id}`);
                                }}
                                // to={`/tenant/detail/active/${result?.id}`}
                                className="p-3 bg-gray-500 rounded-md dark:border-dark-5 hover:bg-gray-600 dark:hover:bg-dark-600 transition-colors cursor-pointer"
                              >
                                <div className="flex flex-col gap-1">
                                  <h4 className="text-lg font-semibold">
                                    {result.name}
                                  </h4>

                                  <div className="flex items-center gap-2 mt-2">
                                    <span className="px-2 py-1 text-xs rounded-full bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200">
                                      {result?.phoneNumber}
                                    </span>

                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>

                        </div>

                      )
                    }

                    {
                      searchResults && searchResults?.data?.leases_index && searchResults?.data.leases_index.length > 0 && (

                        <div className="flex flex-col gap-0">
                          <h2 className="px-10">{t('lease', { count: 2 })}</h2>
                          <div className="flex-1 flex flex-col gap-4 overflow-auto max-h-[60vh] rounded-md mx-10 my-2 bg-gray-800   scrollbar-corner-background-accent scroll-smooth scrollbar-thumb-gray-700 scrollbar-track-gray-800">
                            {searchResults?.data?.leases_index?.map((result, index) => (
                              <div
                                key={index}
                                onClick={() => {
                                  close()
                                  navigate(`/lease/detail/active/${result?.id}`);
                                }}
                                // to={`/lease/detail/active/${result?.id}`}
                                className="p-3 bg-gray-500 rounded-md dark:border-dark-5 hover:bg-gray-600 dark:hover:bg-dark-600 transition-colors cursor-pointer"
                              >
                                <div className="flex flex-col gap-1">
                                  <h4 className="text-lg font-semibold">
                                    {result.name}
                                  </h4>

                                  <div className="flex items-center gap-2 mt-2">
                                    <span className="px-2 py-1 text-xs rounded-full bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200">
                                      Next Payment date: {dayjs(result?.paymentDueDate).format('dddd, MMM D, YYYY')}
                                    </span>

                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>

                        </div>

                      )
                    }


                    {
                      (!searchResults ||
                        (!searchResults?.data?.tenants_index?.length &&
                          !searchResults?.data?.leases_index?.length &&
                          // !searchResults?.data?.units_index?.length &&
                          !searchResults?.data?.properties_index?.length)) && (
                        <div className="flex flex-col items-center justify-center h-full p-10">
                          <EmptyIcon />
                          <p className="text-gray-500 dark:text-dark-2 text-lg mt-4">
                            No results found
                          </p>
                        </div>
                      )
                    }
                  </Modal.Body>



                  {/* Footer */}
                  <div className="border-t border-gray-200 dark:border-dark-5"></div>
                  <div className="flex items-center justify-between p-4">
                    <span className="text-sm text-gray-500 dark:text-dark-2">
                      {(searchResults?.data?.properties_index?.length ?? 0) + (searchResults?.data?.leases_index?.length ?? 0) + (searchResults?.data?.tenants_index?.length ?? 0)} results found
                    </span>
                    <div className="flex items-center gap-4">
                      <div className="flex items-center gap-1">
                        <Kbd>↑</Kbd>
                        <Kbd>↓</Kbd>
                        <span className="text-sm text-gray-500 dark:text-dark-2">
                          to navigate
                        </span>
                      </div>
                      {/* <div className="flex items-center gap-1">
                      <Kbd>Enter</Kbd>
                      <span className="text-sm text-gray-500 dark:text-dark-2">
                        to select
                      </span>
                    </div> */}
                      <div className="flex items-center gap-1">
                        <Kbd>Esc</Kbd>
                        <span className="text-sm text-gray-500 dark:text-dark-2">
                          to close
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
            </>
          )}


          <LocaleSwitcher />
          {/* <Bell size={24}/>
                <MessageSquare size={24} /> 
                <ToggleRightIcon size={24} />  */}
        </div>
      </div>

      {/* <Modal opened={opened} onClose={close} size={"xl"} >
            {getTutorial()}

      </Modal> */}
    </header>
  )
}

export default Header
